import React from 'react';
import { Inbox, CheckCircle2, AlertCircle } from 'lucide-react';

/**
 * Header card showing the active mailbox status.
 *
 * Wave 1u — accepts the aggregate connection summary (OAuth Gmail + OAuth MS
 * + SMTP) so a Microsoft OAuth connection no longer shows "Aucune boîte".
 */
export default function EmailMailboxStatus({ active, connections }) {
  const isActiveSmtp = !!active?.active;
  const connected = connections || {};
  const provider = connected.gmail
    ? { kind: 'gmail', label: 'Gmail', email: connected.gmail.email, detail: 'Lecture, envoi via OAuth Google.' }
    : connected.microsoft
      ? { kind: 'microsoft', label: 'Microsoft 365 / Outlook', email: connected.microsoft.email, detail: 'Lecture, envoi, calendrier via Microsoft Graph.' }
      : isActiveSmtp
        ? { kind: 'smtp', label: 'SMTP/IMAP', email: active.config.from_email, detail: `Serveur ${active.config.host}` }
        : null;

  return (
    <div className="soft-card p-5" data-testid="email-mailbox-status-card">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-10 h-10 rounded-xl bg-[#EEF2FF] flex items-center justify-center">
          <Inbox className="w-5 h-5 text-[#4F46E5]" />
        </div>
        <div>
          <h2 className="text-[18px] font-bold text-[#1A1B2E]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Boîte email d'envoi</h2>
          <p className="text-[12.5px] text-[#6B6C85]">Connectez votre propre adresse pour envoyer devis, factures, contrats et relances.</p>
        </div>
      </div>

      <div className={`mt-4 rounded-xl p-3 flex items-center gap-3 ${provider ? 'bg-[#E6FBF7] border border-[#99F6E4]' : 'bg-[#FEF3C7] border border-[#FCD34D]'}`} data-testid="email-mailbox-status">
        {provider ? (
          <CheckCircle2 className="w-4 h-4 text-[#0F766E]" />
        ) : (
          <AlertCircle className="w-4 h-4 text-[#92400E]" />
        )}
        <div className="flex-1 text-[12.5px]">
          {provider ? (
            <div className="text-[#0F766E]">
              <span className="font-semibold">
                Active — les emails partent depuis <code className="bg-white px-1 rounded">{provider.email}</code> via <strong>{provider.label}</strong>
              </span>
              <div className="text-[11.5px] opacity-80 mt-0.5">{provider.detail}</div>
            </div>
          ) : (
            <span className="text-[#92400E]">{active?.reason || 'Aucune boîte email connectée — choisissez Gmail, Microsoft ou SMTP ci-dessous.'}</span>
          )}
        </div>
      </div>
    </div>
  );
}
